import { Fold } from "@discovery/prelude/lib/control/lens";
import { _ImageOfKind } from "./image";
import { _TxNode2Images, _TxNodeGetter, } from "@discovery/sonic-api-ng-optics-gen/lib/taxonomy-node";
export * from "@discovery/sonic-api-ng-optics-gen/lib/taxonomy-node";
export const _TxNode2Logo = Fold.compose(_TxNodeGetter, _TxNode2Images, _ImageOfKind("logo"));

